import { Link } from "react-router-dom";
import { MapPin, Phone, FileText, ArrowUp } from "lucide-react";
import { LogoFull } from "./Logo";
import { scrollToSection } from "../lib/scroll";
import { COMPANY } from "../data/company";
import { openCookiePreferences } from "../lib/consent";

const NAV = [
    { id: "christ", label: "Christ Wash Systems" },
    { id: "autoriparatore", label: "Autoriparatore" },
    { id: "servizi", label: "Servizi" },
    { id: "chi-siamo", label: "Chi Siamo" },
    { id: "realizzazioni", label: "Realizzazioni" },
    { id: "assistenza", label: "Assistenza" },
    { id: "contatti", label: "Contatti" },
];

export const Footer = () => {

    return (
        <footer data-testid="footer-section" className="bg-[#081426] text-white">
            <div className="mx-auto max-w-[1440px] px-4 py-16 sm:px-8 lg:px-16">
                <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
                    <div>
                        <LogoFull light />
                        <p className="mt-5 text-sm leading-relaxed text-white/55">
                            Concessionario Ufficiale Christ Wash Systems per la Calabria. Forniture
                            tecniche, impianti e assistenza per autolavaggi, officine e industria
                            nel Sud Italia.
                        </p>
                        <span className="mt-5 inline-flex items-center gap-3 rounded-full bg-white px-4 py-2">
                            <img
                                src="/brands/christ-logo.png"
                                alt="Christ Wash Systems"
                                className="h-4 w-auto"
                            />
                            <span className="text-[10px] font-bold uppercase tracking-[0.14em] text-[#0B1F3A]">
                                Concessionario Ufficiale Calabria
                            </span>
                        </span>
                    </div>

                    <div>
                        <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-white/40">
                            Navigazione
                        </h4>
                        <ul className="mt-5 space-y-2.5">
                            {NAV.map((l) => (
                                <li key={l.id}>
                                    <button
                                        data-testid={`footer-link-${l.id}`}
                                        onClick={() => scrollToSection(l.id)}
                                        className="text-sm text-white/70 transition-colors hover:text-[#E30613]"
                                    >
                                        {l.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-white/40">
                            Contatti
                        </h4>
                        <ul className="mt-5 space-y-3 text-sm text-white/70">
                            <li className="flex items-start gap-2.5">
                                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#E30613]" />
                                Sede operativa: {COMPANY.operationalAddress}
                            </li>
                            <li className="flex items-center gap-2.5">
                                <Phone className="h-4 w-4 shrink-0 text-[#E30613]" />
                                <a
                                    href="tel:+390984443552"
                                    className="transition-colors hover:text-white"
                                    data-testid="footer-phone-link"
                                >
                                    +39 0984 443552
                                </a>
                            </li>
                            <li>
                                <a
                                    href="mailto:info@ftmgroup.it"
                                    className="transition-colors hover:text-white"
                                    data-testid="footer-email-link"
                                >
                                    info@ftmgroup.it
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-white/40">
                            Dati Legali
                        </h4>
                        <ul className="mt-5 space-y-2 text-sm text-white/70" data-testid="footer-legal">
                            <li className="flex items-start gap-2.5 font-semibold text-white/90">
                                <FileText className="mt-0.5 h-4 w-4 shrink-0 text-[#E30613]" />
                                {COMPANY.name}
                            </li>
                            <li>Sede legale: {COMPANY.legalAddress}</li>
                            <li>P.IVA: {COMPANY.vat}</li>
                            <li>Codice Fiscale: {COMPANY.fiscalCode}</li>
                            <li>REA: {COMPANY.rea}</li>
                            <li>Capitale sociale: {COMPANY.shareCapital}</li>
                            <li>
                                PEC:{" "}
                                <a href={`mailto:${COMPANY.pec}`} className="hover:text-white">
                                    {COMPANY.pec}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 flex flex-col items-center justify-between gap-5 border-t border-white/10 pt-8 sm:flex-row">
                    <p className="text-xs text-white/45">
                        © {new Date().getFullYear()} {COMPANY.name} — P.IVA {COMPANY.vat}. Tutti i
                        diritti riservati.
                    </p>
                    <div className="flex flex-wrap items-center justify-center gap-5">
                        <Link
                            to="/privacy-policy"
                            data-testid="footer-privacy-link"
                            className="text-xs text-white/45 transition-colors hover:text-white"
                        >
                            Privacy Policy
                        </Link>
                        <Link
                            to="/cookie-policy"
                            data-testid="footer-cookie-link"
                            className="text-xs text-white/45 transition-colors hover:text-white"
                        >
                            Cookie Policy
                        </Link>
                        <button
                            type="button"
                            onClick={openCookiePreferences}
                            data-testid="footer-cookie-preferences"
                            className="text-xs text-white/45 transition-colors hover:text-white"
                        >
                            Preferenze cookie
                        </button>
                        <button
                            data-testid="footer-back-to-top"
                            onClick={() => window.__lenis?.scrollTo(0, { duration: 1.6 })}
                            className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/60 transition-[background-color,color] duration-300 hover:bg-[#E30613] hover:text-white"
                            aria-label="Torna su"
                        >
                            <ArrowUp className="h-4 w-4" />
                        </button>
                    </div>
                </div>
            </div>

        </footer>
    );
};
